import { Box, Flex, Image } from '@chakra-ui/react';
import johnBass from '../images/johnBass.jpg';
import HoverLink from '../components/HoverLink';

// Define all static text data here
const aboutData = {
	title: "Curious about me?",
	paragraphs: [
		"Hey there! My name is John Bajor. I'm a 22-year-old software developer from Houston, TX.",
		<>
			I graduated from <HoverLink text="Louisiana State University" link="https://www.lsu.edu/" color="purple.100"/> in 
			2024 with a Bachelor's in <HoverLink text="Computer Science" link="https://dmae.lsu.edu/" color="yellow.100"/>. 
			I have always loved creating things that excite others, like <HoverLink text="YouTube" link="https://www.youtube.com/@theweeklydetour" color="red.200"/> videos 
			in my room, a 7-year-long <HoverLink text="Dungeons & Dragons" link="https://www.dndbeyond.com/" color="red.100"/> campaign 
			with my friends (yes, really), and <HoverLink text="Zenith Software" link="https://www.zenithsoftware.dev/" color="blue.200"/>, a 
			software development company I founded with my friends in college.
		</>,
		"Although I specialize in UI/UX, I have experience in all facets of software development. Some of my main trades include creating low-fi and hi-fi product designs, managing the system architecture of a project, comprehensive implementation, and general business management.",
		<>
			When I'm not coding, you can find me on stage with my band, <HoverLink text="Speak Easy" link="https://speakeasybandbr.com/" color="orange.200"/>. We perform our original music to audiences across the country. Playing in my band lets me explore my creative side and connect with people through good times!</>,
		"Here are some quick bits about me:",
	],
	listItems: [
		[
			"D&D Miniature Painter",
			"Amateur Videographer"
		],
		[
			"NFL Fanatic",
			"Active freelancer"
		],
	],
	conclusion: "I'm available for freelance work and always eager to take on new challenges. Feel free to reach out and connect with me!",
};

/**
 * About section of the website
 * @returns The About section of the website
 */
export default function About() {
	return (
		<Flex
			id="about"
			flexDirection={{ base: "column-reverse", md: "row" }}
			alignItems="center"
			justifyContent="space-between"
			padding="5%"
			paddingLeft={"10%"}
			paddingRight={"10%"}
			backgroundColor={"black.300"}
		>
			{/* Image */}
			<Box
				flex="1"
				paddingTop={{ base: "10%", md: "0" }}
				marginBottom={{ base: "5", md: "0" }}
				maxWidth={{ base: "80%", md: "40%" }}
				borderColor={"black.300"}
				borderWidth={6}
				boxShadow={"-30px 30px 0px #374151"}
			>
				<Image
					src={johnBass}
					alt="Hero Image"
					objectFit="cover"
					width="100%"
					height="auto"
				/>
			</Box>

			{/* Text Content */}
			<Flex
				flexDirection={"column"}
				width={{ base: "100%", md: "50%" }}
				gap={4}
			>
				{/* Title */}
				<Box
					fontSize={"3xl"}
					fontFamily={"Source Code Pro Variable"}
					fontWeight="600"
					width={"100%"}
					textAlign={{ base: "center", md: "left" }}
					color={"white.200"}
				>
					{aboutData.title}
				</Box>

				{/* Paragraphs */}
				{aboutData.paragraphs.map((paragraph, index) => (
				<Box
					key={index}
					fontSize={"md"}
					fontFamily={"Source Code Pro Variable"}
					fontWeight="500"
					textAlign="left"
					color={"white.300"}
				>
					{paragraph}
				</Box>
				))}

				{/* List */}
				<Flex flexDirection={"row"} gap={10}>
				{aboutData.listItems.map((column, columnIndex) => (
					<Flex key={columnIndex} flexDirection={"column"} gap={2}>
					{column.map((item, itemIndex) => (
						<Flex key={itemIndex} alignItems="center" gap={2}>
						<Box
							fontSize={"md"}
							fontFamily={"Source Code Pro Variable"}
							fontWeight="500"
							textAlign="left"
							color={"white.300"}
						>
							• {item}
						</Box>
						</Flex>
					))}
					</Flex>
				))}
				</Flex>

				{/* Conclusion */}
				<Box
					fontSize={"md"}
					fontFamily={"Source Code Pro Variable"}
					fontWeight="500"
					textAlign="left"
					color={"white.300"}
				>
					{aboutData.conclusion}
				</Box>
			</Flex>
		</Flex>
	);
};
